import { connect } from 'react-redux'
import * as actionCreators from 'redux/setting/eligiblePeople/actionCreators'
import EligiblePeople from './EligiblePeople'
import './style.css'

export default connect(({ eligiblePeople }) => eligiblePeople, actionCreators)(EligiblePeople)
